"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInviteInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var userInfo_1 = require("../../model/userInfo");
var service_1 = require("../../../library/base/service");
var UpdateInviteInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UpdateInviteInfo, _super);
    function UpdateInviteInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '补填邀请人邀请码';
        _this.code = '101183';
        _this.desc = '补填邀请人邀请码';
        _this.requestParams = new userInfo_1.UpdateInviteInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return UpdateInviteInfo;
}(service_1.BaseService));
exports.UpdateInviteInfo = UpdateInviteInfo;
//# sourceMappingURL=updateInviteInfo.js.map